import type { CryptoAsset } from "~/types/assets.types";
import { calculateOwnership } from "../genericCalculations/ownership";
import { calculateCryptoTotalPurchase } from "./totalPurchase";

export const calculateCryptoProfit = (userProduct: CryptoAsset) => {
  const coins = userProduct?.cryptoData || [];
  const ownership = userProduct?.ownership || 0;
  const totalProfits = calculateCryptoTotalProfit(userProduct);

  return coins.reduce((sum, _, index) => {
    const totalProfit = totalProfits?.[index] || 0;
    const profitOwnership = calculateOwnership(totalProfit, ownership);

    return sum + profitOwnership;
  }, 0);
};

export const calculateCryptoTotalProfit = (userProduct: CryptoAsset) => {
  const coins = userProduct?.cryptoData || [];
  const totalPurchases = calculateCryptoTotalPurchase(userProduct);

  return coins.map((coin, index) => {
    const value = coin.coinRate || 0;
    const amount = coin?.amount || 0;
    const totalPurchase = totalPurchases?.[index] || 0;

    return totalPurchase > 0 ? value * amount - totalPurchase : 0;
  });
};

export const calculateCryptoCoinProfitRates = (userProduct: CryptoAsset) => {
  const coins = userProduct?.cryptoData || [];
  const totalProfits = calculateCryptoTotalProfit(userProduct);
  const totalPurchases = calculateCryptoTotalPurchase(userProduct);

  return coins.map((_, index) => {
    const totalProfit = totalProfits?.[index] || 0;
    const totalPurchase = totalPurchases?.[index] || 0;

    if (Number(totalPurchase) === 0) return 0;
    return totalProfit / totalPurchase;
  });
};

export const calculateCryptoWalletProfitRate = (userProduct: CryptoAsset) => {
  const profit = calculateCryptoProfit(userProduct);
  const totalPurchaseSum = calculateTotalPurchasesSum(userProduct);

  if (Number(totalPurchaseSum) === 0) return 0;
  return profit / totalPurchaseSum;
};

export const calculateTotalPurchasesSum = (userProduct: CryptoAsset) => {
  const totalPurchases = calculateCryptoTotalPurchase(userProduct);

  return totalPurchases.reduce((sum, current) => {
    return sum + current;
  }, 0);
};
